import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.number.constructor.js";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import { computed, observable, makeObservable, runInAction } from "mobx";
import { isTrue } from "@dp/common";
import { findMenuItemAvailibity } from "../../utils/common";
import BrandRules from "../../utils/BrandRules";
import moment from "moment";
var OrderHistoryModel = (_class = /*#__PURE__*/function () {
  _createClass(OrderHistoryModel, [{
    key: "setInitialOrderHistoryForReorder",
    value: function setInitialOrderHistoryForReorder(val) {
      var _this = this;

      runInAction(function () {
        _this._orderHistoryForReorder = val.map(function (item) {
          return _objectSpread(_objectSpread({}, item), {}, {
            isOrderAlreadyDecoded: false,
            decodedItems: [],
            isOrderUnAvailable: false,
            commerceItems: []
          });
        });
      });
    }
  }, {
    key: "setOrderHistoryForReorderEachItem",
    value: function setOrderHistoryForReorderEachItem(orderId, orderDetails) {
      var _this2 = this;

      var updatedOrderHistory = this._orderHistoryForReorder.map(function (item) {
        if (item.orderId === orderId) {
          var _orderDetails$order, _orderDetails$order2;

          var decodedItems = _this2._decodeOrderHistoryItems(orderDetails === null || orderDetails === void 0 ? void 0 : (_orderDetails$order = orderDetails.order) === null || _orderDetails$order === void 0 ? void 0 : _orderDetails$order.commerceItems);

          return _objectSpread(_objectSpread({}, item), {}, {
            isOrderAlreadyDecoded: true,
            decodedItems: decodedItems,
            isOrderUnAvailable: _this2._isOrderUnAvailable(decodedItems),
            commerceItems: orderDetails === null || orderDetails === void 0 ? void 0 : (_orderDetails$order2 = orderDetails.order) === null || _orderDetails$order2 === void 0 ? void 0 : _orderDetails$order2.commerceItems
          });
        }

        return item;
      });

      runInAction(function () {
        _this2._orderHistoryForReorder = updatedOrderHistory;
      });
    }
  }, {
    key: "setProfileOrdersAndHistoryForNonLoggedInUsersApp",
    value: function setProfileOrdersAndHistoryForNonLoggedInUsersApp(data) {
      var _this3 = this;

      var profileOrders = [];
      var orderhistory = [];
      data.map(function (item) {
        var _item$order, _item$order2, _item$order3, _item$order4, _item$order5, _item$order6, _item$order7, _item$order8; // construct order history item to match with new types


        var orderObj = {
          orderId: item === null || item === void 0 ? void 0 : (_item$order = item.order) === null || _item$order === void 0 ? void 0 : _item$order.orderId,
          orderNumber: item === null || item === void 0 ? void 0 : (_item$order2 = item.order) === null || _item$order2 === void 0 ? void 0 : _item$order2.orderNumber,
          restaurantName: item === null || item === void 0 ? void 0 : (_item$order3 = item.order) === null || _item$order3 === void 0 ? void 0 : _item$order3.restaurantName,
          submittedDate: item === null || item === void 0 ? void 0 : (_item$order4 = item.order) === null || _item$order4 === void 0 ? void 0 : _item$order4.submittedDate,
          orderType: item === null || item === void 0 ? void 0 : (_item$order5 = item.order) === null || _item$order5 === void 0 ? void 0 : _item$order5.orderType,
          pickupTime: item === null || item === void 0 ? void 0 : (_item$order6 = item.order) === null || _item$order6 === void 0 ? void 0 : _item$order6.pickupTime,
          pickupDate: item === null || item === void 0 ? void 0 : (_item$order7 = item.order) === null || _item$order7 === void 0 ? void 0 : _item$order7.pickupDate,
          items: item === null || item === void 0 ? void 0 : (_item$order8 = item.order) === null || _item$order8 === void 0 ? void 0 : _item$order8.commerceItems.map(function (comm_item) {
            return {
              productid: comm_item.productId,
              productDisplayName: comm_item.displayName,
              productLargeImageUrl: comm_item.productRef.largeImageUrl
            };
          }),
          amount: item.order.priceInfo.total
        };

        var historyItem = _objectSpread(_objectSpread({}, orderObj), {}, {
          isOrderAlreadyDecoded: true,
          decodedItems: [],
          isOrderUnAvailable: false,
          commerceItems: item.order.commerceItems
        }); // push order to profileOrders


        profileOrders.push(orderObj); // push histort to history item

        orderhistory.push(historyItem);
      });
      runInAction(function () {
        _this3._userProfileOrders = profileOrders;
        _this3._orderHistoryForReorder = orderhistory;
      });
    } // call and check availability after menulist is set

  }, {
    key: "checkProfileOrderAvailabilityForNonLoggedInUsersApp",
    value: function checkProfileOrderAvailabilityForNonLoggedInUsersApp() {
      var _this$_orderHistoryFo,
          _this4 = this;

      var updatedOrderHistoryItem = (_this$_orderHistoryFo = this._orderHistoryForReorder) === null || _this$_orderHistoryFo === void 0 ? void 0 : _this$_orderHistoryFo.map(function (item) {
        var decodedItems = _this4._decodeOrderHistoryItems(item === null || item === void 0 ? void 0 : item.commerceItems);

        return _objectSpread(_objectSpread({}, item), {}, {
          decodedItems: decodedItems,
          isOrderUnAvailable: _this4._isOrderUnAvailable(decodedItems)
        });
      });
      runInAction(function () {
        _this4._orderHistoryForReorder = updatedOrderHistoryItem;
      });
    }
  }, {
    key: "orderHistoryForReorder",
    get: function get() {
      return this._orderHistoryForReorder;
    }
  }, {
    key: "currentOrderHistoryItemSummary",
    get: function get() {
      return this._currentOrderHistoryItemSummary;
    },
    set: function set(value) {
      var _this5 = this;

      runInAction(function () {
        _this5._currentOrderHistoryItemSummary = value;
      });
    }
  }, {
    key: "isIndividualOrderHistoryItemLoading",
    get: function get() {
      return this._isIndividualOrderHistoryItemLoading;
    },
    set: function set(value) {
      var _this6 = this;

      runInAction(function () {
        _this6._isIndividualOrderHistoryItemLoading = value;
      });
    }
  }, {
    key: "userProfileOrders",
    get: function get() {
      return this._userProfileOrders;
    },
    set: function set(value) {
      var _this7 = this;

      runInAction(function () {
        _this7._userProfileOrders = value;
      });
    }
  }]);

  function OrderHistoryModel(platformUtil) {
    _classCallCheck(this, OrderHistoryModel);

    _initializerDefineProperty(this, "_currentPickupTime", _descriptor, this);

    _initializerDefineProperty(this, "_unavailableItems", _descriptor2, this);

    _initializerDefineProperty(this, "_currentOrderDetails", _descriptor3, this);

    _initializerDefineProperty(this, "_menuDetail", _descriptor4, this);

    _initializerDefineProperty(this, "_appAttributes", _descriptor5, this);

    _initializerDefineProperty(this, "_selectedOrderId", _descriptor6, this);

    _initializerDefineProperty(this, "_recentOrdersFromLocalStorage", _descriptor7, this);

    _initializerDefineProperty(this, "_orderHistoryForReorder", _descriptor8, this);

    _initializerDefineProperty(this, "_currentOrderHistoryItemSummary", _descriptor9, this);

    _initializerDefineProperty(this, "_isIndividualOrderHistoryItemLoading", _descriptor10, this);

    _initializerDefineProperty(this, "_userProfileOrders", _descriptor11, this);

    makeObservable(this);
  }

  _createClass(OrderHistoryModel, [{
    key: "setAppAttributesData",
    value: function setAppAttributesData(_appAttributes) {
      var _this8 = this;

      runInAction(function () {
        _this8._appAttributes = _appAttributes;
      });
    }
  }, {
    key: "setMenuDetailData",
    value: function setMenuDetailData(_menuDetail) {
      var _this9 = this;

      runInAction(function () {
        _this9._menuDetail = _menuDetail;
      });
    }
  }, {
    key: "setCurrentOrderDetails",
    value: function setCurrentOrderDetails(idDetails) {
      var _this10 = this;

      runInAction(function () {
        _this10._currentOrderDetails = idDetails;
      });
    }
  }, {
    key: "setUnavailableItemsData",
    value: function setUnavailableItemsData(_unavailableItems) {
      var _this11 = this;

      runInAction(function () {
        _this11._unavailableItems = _unavailableItems;
      });
    }
  }, {
    key: "setPickupTimeData",
    value: function setPickupTimeData(data) {
      var _this12 = this;

      runInAction(function () {
        _this12._currentPickupTime = data;
      });
    }
  }, {
    key: "checkMenuItemAvailibility",
    value: function checkMenuItemAvailibility(id, dayPartInfo, advanceOrdering) {
      return this.unavailableProducts["".concat(id)] ? {
        isUnavailable: true,
        unAvailableMessage: ""
      } : findMenuItemAvailibity({
        advanceOrdering: advanceOrdering,
        dayPartInfo: dayPartInfo,
        currentPickupTime: this._currentPickupTime
      });
    }
  }, {
    key: "checkSkuAvailibility",
    value: function checkSkuAvailibility(id) {
      return !!this.unavailableModifiers["".concat(id)];
    }
  }, {
    key: "_isOrderUnAvailable",
    value: function _isOrderUnAvailable(orderItems) {
      var totalOrderItems = orderItems === null || orderItems === void 0 ? void 0 : orderItems.length;
      var unAvailableItemCount = 0;
      orderItems === null || orderItems === void 0 ? void 0 : orderItems.map(function (item) {
        if (!item.isAvailable) {
          unAvailableItemCount += 1;
        }
      });
      return totalOrderItems === unAvailableItemCount;
    }
  }, {
    key: "_decodeOrderHistoryItems",
    value: function _decodeOrderHistoryItems(orderItems) {
      var _this13 = this;

      var menuListAvailableItemIds = this.getMenuListAvailableItemIds;
      return orderItems === null || orderItems === void 0 ? void 0 : orderItems.map(function (item) {
        var _this13$checkMenuItem, _item$productRef, _item$productRef2, _item$priceInfo;

        return {
          id: item === null || item === void 0 ? void 0 : item.id,
          name: item === null || item === void 0 ? void 0 : item.displayName,
          customizations: _this13._decodeOrderHistorySubItems(item === null || item === void 0 ? void 0 : item.subItem),
          isAvailable: !((_this13$checkMenuItem = _this13.checkMenuItemAvailibility(item === null || item === void 0 ? void 0 : item.productId, item === null || item === void 0 ? void 0 : item.dayPartInfo, item === null || item === void 0 ? void 0 : item.advanceOrdering)) !== null && _this13$checkMenuItem !== void 0 && _this13$checkMenuItem.isUnavailable) && !_this13._isModifierAvailable(item === null || item === void 0 ? void 0 : item.subItem) && menuListAvailableItemIds.includes(item.productId),
          isDiscontinued: false,
          // not present in response
          calorieCount: isTrue(!!(item !== null && item !== void 0 && item.calValue), item === null || item === void 0 ? void 0 : item.calValue, isTrue(!!(item !== null && item !== void 0 && item.fdamessage), item === null || item === void 0 ? void 0 : item.fdamessage, "")),
          imageUrl: (item === null || item === void 0 ? void 0 : (_item$productRef = item.productRef) === null || _item$productRef === void 0 ? void 0 : _item$productRef.largeImage) || (item === null || item === void 0 ? void 0 : (_item$productRef2 = item.productRef) === null || _item$productRef2 === void 0 ? void 0 : _item$productRef2.largeImageUrl),
          price: item === null || item === void 0 ? void 0 : (_item$priceInfo = item.priceInfo) === null || _item$priceInfo === void 0 ? void 0 : _item$priceInfo.amount
        };
      });
    }
  }, {
    key: "_isModifierAvailable",
    value: function _isModifierAvailable(subItems) {
      var _this14 = this;

      var modifierAvailability = subItems === null || subItems === void 0 ? void 0 : subItems.some(function (item) {
        return _this14.checkSkuAvailibility(item.catalogRefId);
      });
      return modifierAvailability;
    }
  }, {
    key: "_decodeOrderHistorySubItems",
    value: function _decodeOrderHistorySubItems(subItems) {
      var _this15 = this;

      return subItems === null || subItems === void 0 ? void 0 : subItems.map(function (subItem) {
        var _this15$_appAttribute;

        var newOptionName = new BrandRules((_this15$_appAttribute = _this15._appAttributes) === null || _this15$_appAttribute === void 0 ? void 0 : _this15$_appAttribute.currentConceptCode).cartCustomizationName(subItem === null || subItem === void 0 ? void 0 : subItem.skuDisplayName, subItem === null || subItem === void 0 ? void 0 : subItem.optionType);
        return "".concat(subItem === null || subItem === void 0 ? void 0 : subItem.displayName, " - ").concat(newOptionName);
      });
    }
  }, {
    key: "getPaymentDetails",
    value: function getPaymentDetails(orderId) {
      var _order$order, _order$order$paymentG;

      var details = [];
      var order = this._currentOrderHistoryItemSummary;
      order === null || order === void 0 ? void 0 : (_order$order = order.order) === null || _order$order === void 0 ? void 0 : (_order$order$paymentG = _order$order.paymentGroup) === null || _order$order$paymentG === void 0 ? void 0 : _order$order$paymentG.forEach(function (amount) {
        var _ref;

        details.push({
          creditCardType: amount === null || amount === void 0 ? void 0 : amount.creditCardType,
          amount: (_ref = (amount === null || amount === void 0 ? void 0 : amount.amount) + (amount === null || amount === void 0 ? void 0 : amount.tipAmount) + (amount === null || amount === void 0 ? void 0 : amount.paygrpTipAmount)) !== null && _ref !== void 0 ? _ref : 0,
          paygrpTipAmount: amount === null || amount === void 0 ? void 0 : amount.paygrpTipAmount,
          tipAmount: amount === null || amount === void 0 ? void 0 : amount.tipAmount,
          paymentMethod: amount === null || amount === void 0 ? void 0 : amount.paymentMethod,
          paymentCardToken: amount === null || amount === void 0 ? void 0 : amount.paymentCardToken,
          giftCardNumber: amount === null || amount === void 0 ? void 0 : amount.giftCardNumber,
          giftCardType: amount === null || amount === void 0 ? void 0 : amount.giftCardType,
          walletType: amount === null || amount === void 0 ? void 0 : amount.walletType
        });
      });
      return details;
    }
  }, {
    key: "getItemName",
    value: function getItemName(orderId, itemId) {
      var currentOrder = this.orderHistoryForReorder.filter(function (currentOrder) {
        return currentOrder.orderId === orderId;
      });
      var orderDeatils = currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder[0];
      var currentOrderItem = orderDeatils === null || orderDeatils === void 0 ? void 0 : orderDeatils.commerceItems.filter(function (item) {
        return item.productId === itemId;
      });
      var currentOrderItemDetails = currentOrderItem[0];
      return currentOrderItemDetails === null || currentOrderItemDetails === void 0 ? void 0 : currentOrderItemDetails.displayName;
    }
  }, {
    key: "getRequiredAddToCartData",
    value: function getRequiredAddToCartData(orderId, itemId) {
      var _currentOrderItemDeta, _currentOrderItemDeta2;

      var currentOrder = this._orderHistoryForReorder.filter(function (currentOrder) {
        return currentOrder.orderId === orderId;
      });

      var orderDeatils = currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder[0];
      var currentOrderItem = orderDeatils === null || orderDeatils === void 0 ? void 0 : orderDeatils.commerceItems.filter(function (item) {
        return item.id === itemId;
      });
      var currentOrderItemDetails = currentOrderItem[0];
      return {
        productId: currentOrderItemDetails === null || currentOrderItemDetails === void 0 ? void 0 : currentOrderItemDetails.productId,
        productName: currentOrderItemDetails === null || currentOrderItemDetails === void 0 ? void 0 : currentOrderItemDetails.displayName,
        productPrice: currentOrderItemDetails === null || currentOrderItemDetails === void 0 ? void 0 : currentOrderItemDetails.priceInfo,
        catalogRefIds: currentOrderItemDetails === null || currentOrderItemDetails === void 0 ? void 0 : currentOrderItemDetails.catalogRefId,
        selectedIds: currentOrderItemDetails === null || currentOrderItemDetails === void 0 ? void 0 : (_currentOrderItemDeta = currentOrderItemDetails.subItem) === null || _currentOrderItemDeta === void 0 ? void 0 : (_currentOrderItemDeta2 = _currentOrderItemDeta.map) === null || _currentOrderItemDeta2 === void 0 ? void 0 : _currentOrderItemDeta2.call(_currentOrderItemDeta, function (item) {
          return item === null || item === void 0 ? void 0 : item.selectedId;
        }),
        quantity: currentOrderItemDetails === null || currentOrderItemDetails === void 0 ? void 0 : currentOrderItemDetails.quantity,
        configQuantity: 1,
        fromPage: "reorder",
        smartRecommended: false,
        itemInstructions: currentOrderItemDetails === null || currentOrderItemDetails === void 0 ? void 0 : currentOrderItemDetails.itemInstructions,
        guestName: ""
      };
    }
  }, {
    key: "getRequiredAddAllToCartData",
    value: function getRequiredAddAllToCartData(orderId) {
      var _this16 = this;

      var menuListAvailableItemIds = this.getMenuListAvailableItemIds;

      var currentOrder = this._orderHistoryForReorder.filter(function (currentOrder) {
        return currentOrder.orderId === orderId;
      });

      var orderDeatils = currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder[0];
      return orderDeatils === null || orderDeatils === void 0 ? void 0 : orderDeatils.commerceItems.map(function (item) {
        var _item$subItem, _item$subItem$map;

        var _this16$checkMenuItem = _this16.checkMenuItemAvailibility(item === null || item === void 0 ? void 0 : item.productId, item === null || item === void 0 ? void 0 : item.dayPartInfo, item === null || item === void 0 ? void 0 : item.advanceOrdering),
            isUnavailable = _this16$checkMenuItem.isUnavailable;

        return {
          productId: item === null || item === void 0 ? void 0 : item.productId,
          catalogRefIds: item === null || item === void 0 ? void 0 : item.catalogRefId,
          selectedIds: item === null || item === void 0 ? void 0 : (_item$subItem = item.subItem) === null || _item$subItem === void 0 ? void 0 : (_item$subItem$map = _item$subItem.map) === null || _item$subItem$map === void 0 ? void 0 : _item$subItem$map.call(_item$subItem, function (item) {
            return item === null || item === void 0 ? void 0 : item.selectedId;
          }),
          quantity: item === null || item === void 0 ? void 0 : item.quantity,
          configQuantity: 1,
          fromPage: "reorder",
          smartRecommended: false,
          itemInstructions: item === null || item === void 0 ? void 0 : item.itemInstructions,
          guestName: "",
          isUnavailable: isUnavailable || _this16._isModifierAvailable(item === null || item === void 0 ? void 0 : item.subItem) || !menuListAvailableItemIds.includes(item === null || item === void 0 ? void 0 : item.productId),
          itemCourse: item === null || item === void 0 ? void 0 : item.itemCourse
        };
      });
    }
  }, {
    key: "getMenuListAvailableItemIds",
    get: function get() {
      var _this$_menuDetail, _this$_menuDetail$sub;

      var ids = [];
      (_this$_menuDetail = this._menuDetail) === null || _this$_menuDetail === void 0 ? void 0 : (_this$_menuDetail$sub = _this$_menuDetail.subCategories) === null || _this$_menuDetail$sub === void 0 ? void 0 : _this$_menuDetail$sub.forEach(function (cat) {
        var categories = cat;

        if (categories !== null && categories !== void 0 && categories.menucategories) {
          var subCategories = categories === null || categories === void 0 ? void 0 : categories.menucategories;
          subCategories === null || subCategories === void 0 ? void 0 : subCategories.forEach(function (subCat) {
            var subCatgory = subCat;

            if (subCatgory !== null && subCatgory !== void 0 && subCatgory.menu) {
              var _subCatgory$menu;

              subCatgory === null || subCatgory === void 0 ? void 0 : (_subCatgory$menu = subCatgory.menu) === null || _subCatgory$menu === void 0 ? void 0 : _subCatgory$menu.forEach(function (item) {
                return ids.push(item === null || item === void 0 ? void 0 : item.id);
              });
            }

            if (subCatgory !== null && subCatgory !== void 0 && subCatgory.menucategories) {
              var subSubCategory = subCatgory === null || subCatgory === void 0 ? void 0 : subCatgory.menucategories;
              subSubCategory === null || subSubCategory === void 0 ? void 0 : subSubCategory.forEach(function (subSubCat) {
                var _subSubCat$menu;

                subSubCat === null || subSubCat === void 0 ? void 0 : (_subSubCat$menu = subSubCat.menu) === null || _subSubCat$menu === void 0 ? void 0 : _subSubCat$menu.forEach(function (item) {
                  return ids.push(item === null || item === void 0 ? void 0 : item.id);
                });
              });
            }
          });
        }

        if (categories !== null && categories !== void 0 && categories.menu) {
          var _categories$menu;

          categories === null || categories === void 0 ? void 0 : (_categories$menu = categories.menu) === null || _categories$menu === void 0 ? void 0 : _categories$menu.forEach(function (item) {
            return ids.push(item === null || item === void 0 ? void 0 : item.id);
          });
        }
      });
      return ids;
    }
  }, {
    key: "currentOrderDetails",
    get: function get() {
      return this._currentOrderDetails;
    }
  }, {
    key: "unavailableModifiers",
    get: function get() {
      var _this$_unavailableIte;

      return ((_this$_unavailableIte = this._unavailableItems) === null || _this$_unavailableIte === void 0 ? void 0 : _this$_unavailableIte.modifiersMap) || {};
    }
  }, {
    key: "unavailableProducts",
    get: function get() {
      var _this$_unavailableIte2;

      return ((_this$_unavailableIte2 = this._unavailableItems) === null || _this$_unavailableIte2 === void 0 ? void 0 : _this$_unavailableIte2.productsMap) || {};
    }
  }, {
    key: "selectedOrderId",
    get: function get() {
      return this._selectedOrderId;
    },
    set: function set(_selectedOrderId) {
      var _this17 = this;

      runInAction(function () {
        _this17._selectedOrderId = _selectedOrderId;
      });
    }
  }, {
    key: "recentOrder",
    get: function get() {
      var _this$orderHistoryFor;

      return (_this$orderHistoryFor = this.orderHistoryForReorder) === null || _this$orderHistoryFor === void 0 ? void 0 : _this$orderHistoryFor[0];
    }
  }, {
    key: "recentOrderBasicDetails",
    get: function get() {
      var order = null;

      if (this._userProfileOrders) {
        var _this$_userProfileOrd;

        order = (_this$_userProfileOrd = this._userProfileOrders) === null || _this$_userProfileOrd === void 0 ? void 0 : _this$_userProfileOrd[0];
        if (order) return order;
      }

      return null;
    }
  }, {
    key: "previousOrders",
    get: function get() {
      var _this$_orderHistoryFo2, _this$_orderHistoryFo3;

      return (_this$_orderHistoryFo2 = this._orderHistoryForReorder) === null || _this$_orderHistoryFo2 === void 0 ? void 0 : (_this$_orderHistoryFo3 = _this$_orderHistoryFo2.slice) === null || _this$_orderHistoryFo3 === void 0 ? void 0 : _this$_orderHistoryFo3.call(_this$_orderHistoryFo2, 1);
    }
  }, {
    key: "previousOrdersBasicDetails",
    get: function get() {
      if (this._userProfileOrders) {
        var _this$_userProfileOrd2;

        var allPreviousOrders = (_this$_userProfileOrd2 = this._userProfileOrders) === null || _this$_userProfileOrd2 === void 0 ? void 0 : _this$_userProfileOrd2.slice(1);
        return allPreviousOrders;
      }

      return null;
    }
  }, {
    key: "expiryTime",
    get: function get() {
      var _this$_appAttributes, _this$_appAttributes$;

      var expiryDays = ((_this$_appAttributes = this._appAttributes) === null || _this$_appAttributes === void 0 ? void 0 : (_this$_appAttributes$ = _this$_appAttributes.configs) === null || _this$_appAttributes$ === void 0 ? void 0 : _this$_appAttributes$.orderLookupExpiryDays) || 0;
      var numberOfDays = Math.abs(Number(expiryDays)); // return moment
      //   .duration(numberOfDays, "days")
      //   .humanize()
      //   .replace("a ", "1 ");

      var start = moment();
      var end = moment().add(numberOfDays, "days");
      var years = end.diff(start, "year");
      start.add(years, "years");
      var months = end.diff(start, "months");
      start.add(months, "months");
      var days = end.diff(start, "days");
      var yearsDisplay = years > 0 ? years + (years == 1 ? " year " : " years ") : "";
      var monthsDisplay = months > 0 ? months + (months == 1 ? " month " : " months ") : "";
      var daysDisplay = days > 0 ? days + (days == 1 ? " day" : " days") : "";
      return yearsDisplay + monthsDisplay + daysDisplay;
    }
  }]);

  return OrderHistoryModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_currentPickupTime", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_unavailableItems", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_currentOrderDetails", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_menuDetail", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_appAttributes", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "_selectedOrderId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "_recentOrdersFromLocalStorage", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "_orderHistoryForReorder", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "_currentOrderHistoryItemSummary", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "_isIndividualOrderHistoryItemLoading", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "_userProfileOrders", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "getMenuListAvailableItemIds", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "getMenuListAvailableItemIds"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentOrderDetails", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentOrderDetails"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "unavailableModifiers", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "unavailableModifiers"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedOrderId", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedOrderId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "recentOrder", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "recentOrder"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "recentOrderBasicDetails", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "recentOrderBasicDetails"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "previousOrders", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "previousOrders"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "previousOrdersBasicDetails", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "previousOrdersBasicDetails"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "expiryTime", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "expiryTime"), _class.prototype)), _class);
export { OrderHistoryModel as default };